module.exports = __webpack_public_path__ + "static/media/BigMathMatchIcon.3f49f5a0.svg";